module.exports = __webpack_public_path__ + "b320f9ed36ec3405721b2572d96699d9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-pirate.png
// module id = 3237
// module chunks = 0